import { router } from '@/ui/routes';
import { SessionStorageKeys } from '@/entities/checklist';

export function useChecklistSessionStorage() {
  const exitAction = () => {
    router.push({ name: window.sessionStorage.getItem(SessionStorageKeys.ChecklistQuitRoute) || 'home' });
  };

  const cleanAiForm = () => {
    sessionStorage.removeItem(SessionStorageKeys.AiTemplate);
  };

  const saveToStorage = (key: SessionStorageKeys, data: string|null) => {
    if (!data) {
      sessionStorage.removeItem(key);

      return;
    }

    sessionStorage.setItem(key, data);
  };

  const saveForm = (data: string|null) => { saveToStorage(SessionStorageKeys.AiTemplate, data); };
  const saveExitRoute = (route: string) => { saveToStorage(SessionStorageKeys.ChecklistQuitRoute, route); };

  return {
    exitAction,
    cleanAiForm,
    saveForm,
    saveExitRoute,
  };
}
